import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

import { LocaleFormat } from '../../models';

@Pipe({
  name: 'mqaCurrency',
  standalone: false,
})
export class MqaCurrencyPipe implements PipeTransform {
  constructor(
    public currencyPipe: CurrencyPipe,
    public decimalPipe: DecimalPipe
  ) {}

  transform(value: number | undefined, localeFormat: LocaleFormat): any {
    if (value === undefined || value === null || isNaN(value)) {
      return '';
    }

    if (localeFormat && localeFormat.CurrencyCode !== 'JPY') {
      return this.currencyPipe.transform(
        value,
        localeFormat.CurrencyCode,
        'symbol-narrow',
        '1.0-0'
      );
    } else {
      return this.decimalPipe.transform(value, '1.0-0');
    }
  }
}
